import styled, { css } from 'styled-components';

export const BackgroundWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    border-radius: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      background: '#ffffff';
      border-radius: 0;
      padding: 0;
    }
  `}
`;

export const GuideContainer = styled.div`
  ${({ theme }) => css`
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 9999;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      display: none;
    }
  `};
`;

export const HighlightWrapper = styled.div`
  ${({ theme, $width, $backgroundStudio }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 40px;
    padding: 32px 24px;
    position: relative;
    width: ${`calc(${$width || 100}% - ${!$width || $width === 100 ? '0px' : '8px'})`};
    min-height: 430px;
    border-radius: 16px;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 16px;
      pointer-events: none;
      background: linear-gradient(180deg, #D7BDE8 0%, #FEE3C8 100%);
      opacity: ${$backgroundStudio ? 1 : 0};
      transition: opacity 0.4s;
      z-index: 0;
    }

    > * {
      position: relative;
      z-index: 1;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0;
      gap: 0;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      min-height: 196px;
      flex-direction: column;
      gap: 0;
      align-items: center;
      white-space: nowrap;
      overflow-x: auto;
    }
  `}
`;

export const MenuHighlight = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    gap: 24px;
    justify-content: center;
    scroll-behavior: smooth;
    white-space: nowrap;
    overflow-x: auto;
    padding-top: 16px;
    margin-top: -16px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      gap: 8px;
      justify-content: flex-start;
      overflow-x: scroll;
      padding: 16px 20px 12px 20px;
      width: 100%;
    }

    ::-webkit-scrollbar {
      display: none;
    }
  `}
`;

export const MenuHighlightButton = styled.button`
  ${({ theme, active }) => css`
    align-items: center;
    background-color: ${active ? theme.v2.colors.brand.primaryLowLight : theme.v2.colors.neutral.highPure};
    border: none;
    border-radius: 39.5px;
    color: ${theme.v2.colors.brand.primaryExtraDark};
    cursor: pointer;
    display: flex;
    flex: 0 0 auto;
    justify-content: center;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    outline: none;
    padding: 12px 24px;
    transition: background-color 0.3s;
    position: relative;

    :hover {
      background-color: ${theme.v2.colors.brand.primaryLowLight};
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 12px;
    }
  `}
`;

export const TagNewAdapter = styled.span`
  position: absolute;
  top: -13px;
  right: 16px;
`;

export const MenuHighlightIcon = styled.div`
  display: flex;
  padding-right: 8px;
`;

export const MenuHighlightTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const SkeletonHighlightWrapper = styled.div`
  ${({ theme, skeleton, width }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 40px;
    justify-content: ${skeleton ? 'flex-start' : 'center'};
    min-height: 430px;
    padding: ${skeleton ? '44px 0 70px 0' : '32px 0'};
    position: relative;
    width: ${`calc(${width || 100}% - ${!width || width === 100 ? '0px' : '8px'})`};

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      min-height: 196px;
      flex-direction: column;
      gap: 0;
      align-items: center;
      white-space: nowrap;
      overflow-x: auto;
      padding: ${skeleton ? '44px 0 70px 0' : '24px 0'};
    }
  `}
`;

export const SkeletonWrapper = styled.div`
  ${({ theme, column, alignStart }) => css`
    align-items: ${alignStart ? 'flex-start' : 'center'};
    display: flex;
    flex-direction: ${column ? 'column' : 'row'};
    flex-wrap: wrap;
    gap: ${column ? '44px' : '20px'};
    justify-content: center;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      gap: 20px;

      div {
        max-width: 320px;
      }
    }
  `}
`;

export const WrapperTitle = styled.div`
  align-items: center;
  display: flex;
  gap: 6px;
  justify-content: center;
`;

export const GuidePopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 320px;
`;

export const GuidePopoverTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.bold};
    margin: 0;
  `}
`;

export const GuidePopoverDescription = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    margin: 0;
  `}
`;

export const CarouselWrapper = styled.div`
  ${({ theme }) => css`
    background-color: #ffffff;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 40px;
    overflow: hidden;
    padding: 32px;
    position: relative;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 24px 0;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      gap: 0;
    }
  `}
`;

export const CarouselContainer = styled.div`
  display: flex;
  transition: transform 0.3s ease;
  width: 100%;
`;

export const CarouselItem = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 100%;
  justify-content: center;
  max-width: 100%;
  margin-bottom: auto;
`;


export const DivContents = styled.div`
  ${({ theme }) => css`
    align-items: flex-start;
    display: flex;
    gap: 48px;
    justify-content: center;
    min-height: 343px;
    padding: 0 32px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      gap: 16px;
      padding: 0 20px;
    }
    
    @media (max-width: ${theme.v2.breakpoints.lg}) {
      align-items: center;
      flex-direction: column;
      gap: 32px;
      white-space: normal;
    }
  `}
`;

export const DivImg = styled.div`
  ${({ theme }) => css`
    width: 50%;
    max-width: fit-content;
    display: flex;
    justify-content: flex-end;

    img {
      width: 100%;
      max-width: 573px;
    }

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      width: 100%;
      order: 0;
      justify-content: center;
      padding-top: 24px;
    }
  `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
      color: ${theme.v2.colors.brand.primaryBlue};
      font-family: ${theme.v2.font.family.primary};
      font-size: 20px;
      font-weight: ${theme.v2.font.weights.medium};
      line-height: 1.5;
      margin: 0px;

      @media (max-width: ${theme.v2.breakpoints.sm}) {
        font-size: ${theme.v2.font.sizes.sm2};
      }

      strong {
        font-weight: 500;
      }
  `}
`;

export const WrapperTitle2 = styled.div`
 ${({ theme }) => css`
  align-items: center;
  display: flex;
  gap: 6px;
  justify-content: center;
  margin: 0px 0px 16px 0px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin: 0 auto 16px auto;
    }
  `}
`;

export const DivText = styled.div`
  ${({ theme }) => css`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    max-width: 460px;
    width: 50%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      max-width: 100%;
    }

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      align-items: center;
      max-width: 573px;
      text-align: center;
      width: 100%;
    }
  `}
`;

export const ButtonWrapper = styled.div`
 ${({ theme }) => css`
    display: flex;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      order: 2;
      width: 100%;
      max-width: 100%;
    }
 `}
`;

export const Subtitle = styled.p`
 ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryBlue};
    font-family: ${theme.v2.font.family.primary};
    font-size: 28px;
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 140%;
    margin: 0px 0px 20px 0px;
    max-width: 340px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.sm2};
      margin: 0 auto 16px auto;
    }

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      max-width: 100%;
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px 0px 24px 0px;
 
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;
